module.exports = __webpack_public_path__ + "static/referral_logo2.9d6c4a94.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/referral_logo2.png
// module id = 3190
// module chunks = 246501157640856